class GaiaTicker extends HTMLElement {
  constructor() {
    super();
    this.isPaused = false;
  }

  connectedCallback() {
    this.refreshAnnouncementBar();
    window.addEventListener("resize", this.refreshAnnouncementBar.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener(
      "resize",
      this.refreshAnnouncementBar.bind(this)
    );
  }

  // Set up ticker
  refreshAnnouncementBar() {
    const ticker = this;
    const sectionWidth = ticker.getBoundingClientRect().width;
    const tickerItems = ticker.querySelector(".ticker-items");
    const tickerWidth = tickerItems.getBoundingClientRect().width;
    const tickerScroller = ticker.querySelector(".ticker-scroller");

    ticker.style.setProperty("--ticker-width", tickerWidth + "px");
    ticker.style.setProperty("--ticker-width-mobile", tickerWidth + "px");
    ticker.style.setProperty("--ticker-move", "-" + tickerWidth + "px");
    ticker.style.setProperty("--ticker-move-mobile", "-" + tickerWidth + "px");

    const tickerCopies = ticker.querySelectorAll(".ticker-duplicates");
    tickerCopies.forEach((tickerCopy) => {
      tickerCopy.remove();
    });

    for (
      let w = tickerWidth;
      w < sectionWidth + tickerWidth;
      w += tickerWidth
    ) {
      const tickerCopy = tickerItems.cloneNode(true);
      tickerCopy.classList.add("ticker-duplicates");
      tickerCopy.setAttribute("aria-hidden", true);
      tickerScroller.appendChild(tickerCopy);
    }
    tickerScroller.style.opacity = "1";
  }
}

customElements.define("gaia-ticker", GaiaTicker);
